import { AxiosRequestConfig } from 'axios';

import { checkIfTokenExpired } from '@/utils/Auth';

import { GetUserDetailsById } from '../InsertData/types';
import request from '../request';

import {
  CreateCompleteUser,
  SendTemporaryCredentialsBody,
  UpdateCompleteUser,
  UserAuth,
  UserDetail,
  UserMeProps,
} from './types';

export const login = (formData: UserAuth) => request.post('/account/login/token/', formData);

export const resetpassword = async ({ email }: { email: string }) => {
  const { data } = await request.post('/account/login/resetpassword/', {
    email,
  });

  return data;
};

export const changepassword = async ({
  token,
  newPassword,
}: {
  token: string;
  newPassword: string;
}) => {
  const config: AxiosRequestConfig & { skipAuth: boolean } = {
    skipAuth: true,
  };

  const { data } = await request.post(
    '/account/login/changepassword/',
    {
      token,
      new_password: newPassword,
    },
    config,
  );

  return data;
};

export const sendEmailWithUserCredentials = async (
  userId: number,
  data: SendTemporaryCredentialsBody,
) => request.post(`/account/user/${userId}/send_temporary_credentials`, data);

export const getAccountUserDetailsByUserId = async (id: number) => {
  const { data } = await request.get<GetUserDetailsById>(`/account/user/${id}`);
  return data;
};

export const create = async (data: UserDetail) => request.post('/account/user/', data);

export const postUser = async (data: CreateCompleteUser) => {
  const { data: response } = await request.post('/account/user/', data);
  return response as GetUserDetailsById;
};

export const createGuest = async (data: UserDetail) => {
  await create(data);
};

export const putUser = async (id: number, data: UserDetail) => {
  await request.put(`/account/user/${id}/`, {
    ...data,
  });
};

export const patchUser = async (id: number, data: UserDetail) => {
  await request.patch(`/account/user/${id}/`, {
    ...data,
  });
};

export const patchAccountUser = async (id: number, data: UpdateCompleteUser) => {
  const response = await request.patch(`/account/user/${id}/`, {
    ...data,
  });

  return response.data as GetUserDetailsById;
};

export const getUserMe = async () => {
  try {
    const { data } = await request.get<UserMeProps>('/account/user/me/');
    return data as UserMeProps;
  } catch (e) {
    const tokenExpired = checkIfTokenExpired();
    if (tokenExpired) {
      window.localStorage.removeItem('sapron-pms-user');
    }
    return null;
  }
};

const getRoles = (response: UserMeProps): string[] => {
  let roles: string[] = response?.roles || [];
  const departmanet = response?.seazone?.departmanet?.trim() || '';

  if (roles.includes('Seazone') && ['Onboarding', 'Administrative'].includes(departmanet)) {
    roles.push(`Seazone${departmanet}`);
    roles = roles.filter((role) => role !== 'Seazone');
  }

  return roles;
};

export const getUserInformation = async () => {
  const response = await getUserMe();
  if (response) {
    const userDetails: UserMeProps = {
      ...response,
      user_id: response?.id?.toString() || '',
      roles: [...getRoles(response)],
      required_actions: response?.required_actions?.Partner ? {} : response.required_actions || {}, // Hotfix acordado com o time em: 05/04/2025 -> Se o usuario for parceiro, o required_actions é vazio pois não é necessário exibir Popups para Parceiros.
    };
    return userDetails;
  }
  return null;
};

export interface IChangeRequiredActions {
  user_id: UserMeProps['user_id'];
  body: UserMeProps['required_actions'];
}

export const changeRequiredActions = async ({ user_id, body }: IChangeRequiredActions) => {
  const response = await request.patch(`/account/user/${user_id}/required_actions/`, {
    required_actions: body,
  });

  return response as unknown as IChangeRequiredActions;
};
